<script setup>
const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  isShow: {
    type: Object,
    required: true,
  },
  titleText: {
    type: String,
    required: true,
  },
  submitText: {
    type: String,
    required: true,
  }
});
const emits = defineEmits(['request-close', 'request-submit']);
</script>

<template>
  <div v-if="isShow">
    <div :class="{modModalWindow: true, mdPopUp: true, isShow}">
      <div class="modModalTitleContainer">
        <p class="pFont16 pFontBold">{{titleText}}</p>
        <button
          type="button"
          class="lyHvCnt lyColumn lyW48px lyH48px pFont10 pFontBold"
          @click="emits('request-close')"
        >
      <span class="lyBlock lyW24px"><img
        :src="siteUrl+'images/iconClose.svg'"
        loading="lazy"
        alt="" width="30"
        height="31"
      ></span>
          とじる
        </button>
      </div>
      <div class="modModalBottomWrapper">
        <div class="lyPd16">
          <slot></slot>
        </div>
        <div class="lyMtAuto">
          <div class="lyHorizontal pBorderTop2pxSolidGray4">
            <p :class="{lyW100: submitText === '', lyW50: submitText !== '', pBorderRight2pxSolidGray4: submitText !== ''}">
              <button
                type="button"
                class="lyW100 lyPt16 lyPb16 pFont14 pFontBold"
                @click="emits('request-close')"
              >とじる</button>
            </p>
            <p
              v-if="submitText !== ''"
              class="lyW50"
            >
              <button
                type="button"
                class="lyW100 lyPt16 lyPb16 pFont14 pFontBold pFontGreen"
                @click="emits('request-submit')"
              >{{submitText}}</button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{gbModalBack: true, mdPopUp: true, isShow}"
      @click="emits('request-close')"
    ></div>
  </div>
</template>